import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subCategory'
})
export class SubCategoryPipe implements PipeTransform {

  transform(valueArray: any[], supply_category_id: string, searchTerm?: string): any {
    console.log(searchTerm);
    if(supply_category_id && searchTerm){
      return valueArray.filter(single=>single.supply_category_id === supply_category_id && single.name.toLowerCase().includes(searchTerm.toLowerCase()));
    } else if(supply_category_id){
      return valueArray.filter(single=>single.supply_category_id === supply_category_id);
    } else {
      return [];
    }
  }

}
